import {memo, useMemo} from "react";
import {Button, CardContent, CardContentProps, Grid2Props, Typography, Unstable_Grid2 as Grid} from '@mui/material';

const MuiYearSelector = ({year = new Date().getFullYear(), selectedYear, range = 10, cols=3, onSelect = () => {}, sx}:{
    year?: number,
    range?: number,
    sx?: CardContentProps['sx'],
    cols?:Grid2Props['xs'],
    onSelect?: (year?:number) => void,
    selectedYear?: number,
}) => {

    const years = useMemo<number[]>(() => {
        const arr = new Array(range * 2 + 1);
        const minYear = (selectedYear || year) - range;

        for (let i = 0; i < arr.length; i++) {
            arr[i] = minYear + i;
        }

        return arr;
    }, [year, range])


    return (
        <CardContent sx={sx}>
            <Grid container>
                {years.map((cYear, idx) => {
                    // const isCurrent = !!selectedYear ? selectedYear === cYear : year === cYear;
                    const isSelected = !!selectedYear ? (selectedYear === cYear) : (year === cYear);

                    return (
                        <Grid key={cYear} xs={cols}>
                            <Button variant={isSelected ? 'contained' : undefined} onClick={() => {
                                onSelect(cYear);
                            }} sx={{
                                backgroundColor: isSelected ? 'var(--v-mui-datepicker-selected-color)' : undefined
                            }}>
                                <Typography color={isSelected ? 'var(--v-mui-datepicker-selected-text)' : 'var(--v-mui-datepicker-text-color)'}>
                                    {cYear}
                                </Typography>
                            </Button>
                        </Grid>
                    )
                })}
            </Grid>
        </CardContent>
    )
}

export default memo(MuiYearSelector);
